import { LEAGUE_LABELS } from '@pickleballinc/lib/product-labels';

import { Module, ModuleCardAppColor, ModuleLookup } from './types';

export const LOOKUP: Record<Module, ModuleLookup> = {
	tournament: {
		entityName: 'Tournament',
		btnBgColor: 'bg-[#155EEF]',
		btnBorderColor: 'border-[#6C9AF5]',
		btnLabelColor: 'text-[#104BBF]',
		imgFallbackColor: 'bg-[#104BBF]'
	},
	clubs: {
		entityName: 'Club',
		btnBgColor: 'bg-error-700',
		btnBorderColor: 'border-[#D0756E]',
		btnLabelColor: 'text-clubs-300',
		imgFallbackColor: 'bg-clubs-300'
	},
	'team-leagues': {
		entityName: 'Team League',
		btnBgColor: 'bg-darkorange-400',
		btnBorderColor: 'border-[#F7B27A]',
		btnLabelColor: 'text-[#FF5005]',
		imgFallbackColor: 'bg-[#FF5005]'
	},
	leagues: {
		entityName: LEAGUE_LABELS.singular,
		btnBgColor: 'bg-[#D7365B]',
		btnBorderColor: 'border-[#E68198]',
		btnLabelColor: 'text-[#AC2B48]',
		imgFallbackColor: 'bg-[#AC2B48]'
	}
};

export const backdropVariants = {
	hidden: { opacity: 0 },
	visible: { opacity: 1, transition: { duration: 0.1 } }
};

export const MODULE_CARD_APP_COLORS: Record<Module, ModuleCardAppColor> = {
	tournament: { color: '#010C33', hoverColor: '#011046' },
	clubs: { color: '#010C33', hoverColor: '#011046' },
	leagues: { color: '#010C33', hoverColor: '#011046' },
	'team-leagues': { color: '#010C33', hoverColor: '#011046' }
};

export const PARTNER_GRADIENT_COLORS = {
	tournament: ['#000D27', '#001B4F'],
	'team-leagues': ['#110700', '#110700'],
	leagues: ['#220013', '#220013'],
	clubs: ['#3D0000', '#3D0000']
} as const satisfies Record<Module, readonly [string, string]>;

export const FEATURED_GRADIENT_COLORS = {
	tournament: '#000D27',
	'team-leagues': '#110700',
	leagues: '#220013',
	clubs: '#3D0000'
} as const satisfies Record<Module, string>;
